<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-form-group label="Country">
            <b-form-select
              v-model="params.country"
              :options="countries"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="From">
            <b-form-datepicker v-model="params.from" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="To">
            <b-form-datepicker
              v-model="params.to"
              :disabled="!params.from"
              :min="params.from"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          class="d-flex justify-content-end align-items-center"
        >
          <b-button
            variant="primary"
            :disabled="fetching || !params.from || !params.to"
            @click="fetchRegistrationReports"
          >
            <b-spinner
              v-if="fetching"
              small
            />
            <span v-else>Search</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="isDataFetchedForFirstTime && !fetching">
      <b-button
        :disabled="data.length == 0"
        variant="primary"
        class="mb-1"
        @click="downloadHandler"
      >
        <div>
          <feather-icon
            class="mr-1"
            icon="DownloadIcon"
            size="16"
          />
          <span>Download</span>
        </div>
      </b-button>
      <b-table
        :fields="cols"
        :items="data"
        show-empty
        responsive
        empty-text="No reports found"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BSpinner,
  BTable,
  BFormDatepicker,
  BButton,
  BCard,
  BFormSelect,
  BFormGroup,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../driverStoreModule'
import { errorNotification } from '@/utils/toast-notifications'
import { isJordanianAdmin } from '@/utils/validate-admin-country'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BSpinner,
    BFormDatepicker,
    BButton,
    BCard,
    BFormGroup,
    BFormSelect,
  },
  setup(_, ctx) {
    useRegisterStoreModule('drivers', store)
    const params = ref({
      from: null,
      to: null,
      country: 'JO',
    })
    const countries = [
      { text: 'Libya', value: 'LY' },
    ]
    if (isJordanianAdmin()) {
      countries.push({ text: 'Jordan', value: 'JO' })
    }
    const isDataFetchedForFirstTime = ref(false)
    const cols = [
      'id',
      {
        label: 'phone number',
        key: 'phoneNumber',
      },
      'name',
      'Actor',
      'city',
      'class',
      'model',
      'type',
      'created_at',
    ]
    const fetching = ref(false)
    const data = ref([])
    const fetchRegistrationReports = async () => {
      try {
        if (params.value.from && params.value.to) {
          if (new Date(params.value.from).getTime() > new Date(params.value.to).getTime()) {
            errorNotification('From date cannot be larger than to date')
            return
          }
        }
        fetching.value = true
        const res = await ctx.root.$store.dispatch(
          'drivers/fetchRegistrationReports',
          params.value,
        )
        const { items } = res.data.data
        if (items) {
          data.value = items.map(el => ({
            ...el,
            phoneNumber: el?.phoneNumber || el.phomeNumber,
          }))
        }
        isDataFetchedForFirstTime.value = true
      } catch (error) {
        errorNotification('Error fetching reports')
      } finally {
        fetching.value = false
      }
    }

    const downloadHandler = () => {
      let csv = 'id,Phone Number,Name,Actor,City,Class,Model,Type,Created At\n'
      const temp = data.value.map(row => ({
        id: row.id,
        phoneNumber: row.phoneNumber,
        name: row.name,
        actor: row.Actor,
        city: row.city,
        class: row.class,
        model: row.model,
        type: row.type,
        createdAt: row.created_at,
      }))
      // Loop through the array
      temp.forEach(row => {
        const rowValues = Object.entries(row)

        const rowLength = rowValues.length
        // Loop through each object
        rowValues.forEach((key, index) => {
          // Last item reached, set a new line
          if (index + 1 === rowLength) {
            csv += `${key[1]}\n`
            return
          }
          // assign a comma for each cell
          csv += `${key[1]},`
        })
      })
      const link = document.createElement('a')
      link.id = 'download-csv'
      link.setAttribute(
        'href',
        `data:text/plain;charset=utf-8,${encodeURIComponent(csv)}`,
      )
      link.setAttribute('download', `registration-reports ${params.value.from} / ${params.value.to}.csv`)
      document.body.appendChild(link)
      document.querySelector('#download-csv').click()
    }

    return {
      downloadHandler,
      params,
      isDataFetchedForFirstTime,
      data,
      fetchRegistrationReports,
      fetching,
      countries,
      cols,
    }
  },
}
</script>

<style></style>
